export default ({...props}) => {
  const {space, size} = props.theme
  return `
        display: flex;
        flex-flow: column;
        gap: ${space(2.5)}px;
        margin-top: ${space(2.5)}px;

        & > .MuiCard-root {
            padding: ${space(2)}px 0;

            & .MuiCardHeader-root {
                padding-bottom: 0;
                padding-top: 0;
                & .visit-title-wrapper {
                    display: flex;
                    align-items: center;
                    gap: ${space(0.45)}px;
                    & > p {
                        margin: 0;
                    }
                }
                & .visit-action-wrapper {
                    & > button.MuiCardActionArea-root {
                        &:hover,
                        &:focus{
                           & > .MuiCardActionArea-focusHighlight {
                                opacity: 0;
                           }
                        }
                        & > p {
                            display: flex;
                            margin: 0;
                            text-transform: capitalize;
                            & > svg {
                                position: relative;
                                bottom: 1px;
                                transform: rotate(0);
                                transition: all 0.3s;
                                &[aria-expanded="true"]{
                                    transform: rotate(180deg);
                                }
                            }
                        }
                    }
                }
    
                @media screen and (max-width: 376px){ 
                    & {
                        flex-flow: row wrap;
                        justify-content: flex-end;
                    }
                    
                }
            }
    
            & .btn-wrapper {
                display: flex;
                justify-content: flex-end;
                gap: ${space(1.25)}px;
                & > button {
                    text-transform: capitalize;
                }
    
                @media screen and (max-width: 891px){
                    & > button {
                        width: ${size(12.5)}%;
                    }
                }

                @media screen and (max-width: 476px){
                    flex-direction: column;
                }
    
                @media screen and (max-width: 375px){
                    & > button {
                        font-size: 0.9rem;
                    }
                }

                @media screen and (max-width: 320px){
                    & > button {
                        font-size: 0.8rem;
                    }
                }
            }
    
            & .progressbar-wrapper {
                display: flex;
                flex-direction: column;
                gap: ${space(1.25)}px;
                margin-top: ${space(2.5)}px;
                
                &.mobile {
                    padding: 0 ${space(2)}px;
                }
                & div.MuiBox-root.instruction-wrapper p.MuiTypography-body1[ahd_type="sData"] {
                    display:block;
                    word-wrap: break-word;
                }
            }

            & div.leaflet-container {
                height: ${size(31.5)}px;
                width: ${space(12.5)}%;
                margin-top: ${space(2)}px;
            }
        }
        
    `
}
